import React from "react";
import ReactDOMServer from "react-dom/server";
import {ShopOutlined} from "@ant-design/icons";
import {subcompanyColor} from "../../../constants/constants";
import config from "../../../_core/config";

export const SubcompanyMarker = ({subcompany, isPoolCustomer = false}) => {
    // Pool customer için sadece firma adını göster
    if (isPoolCustomer) {
        const poolCustomerIconHtml = ReactDOMServer.renderToString(
            <div
                style={{
                    width: "32px",
                    height: "32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: subcompanyColor,
                    borderRadius: "50%",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    border: "2px solid #fff",
                    cursor: "pointer"
                }}
            >
                <ShopOutlined style={{color: "white", fontSize: "16px"}} />
            </div>
        );
        return poolCustomerIconHtml;
    }

    // Normal customer için company marker veya shop icon
    const subcompanyIconHtml = ReactDOMServer.renderToString(
        <div
            style={{
                width: "32px",
                height: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: subcompanyColor,
                borderRadius: "50%",
                boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                border: "2px solid #fff",
                cursor: "pointer"
            }}
        >
            {subcompany.companyMarker ? (
                <img
                    src={`${config.getBasePublicUrl()}api/panel/v1/image/${
                        subcompany.companyMarker
                    }`}
                    style={{
                        width: "20px",
                        height: "20px",
                        borderRadius: "50%"
                    }}
                    alt="Company"
                />
            ) : (
                <ShopOutlined style={{color: "white", fontSize: "16px"}} />
            )}
        </div>
    );

    return subcompanyIconHtml;
};
